import * as React from 'react';
import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps, Tooltip } from '@mui/material';

interface ToggleSwitchProps {
    checked: boolean,
    label: string,
    labelProps?: FormControlLabelProps,
    onChange: (e) => void,
    switchProps?: SwitchProps,
    tooltipTitle?: string,
}

const ToggleSwitch: React.FC<ToggleSwitchProps> =  ({
    checked,
    label,
    labelProps,
    onChange,
    switchProps,
    tooltipTitle,
}) => {
  return (
    <Tooltip title={tooltipTitle}>
        <FormControlLabel
            control={
                <Switch
                    checked={checked}
                    color="primary"
                    onChange={onChange}
                    sx={{
                        ...switchProps?.sx
                    }}
                    {...switchProps}
                />
            }
            label={label}
            sx={{
                '& .MuiFormControlLabel-label': {
                    color: '#fff'
                },
                ...labelProps?.sx
            }}
            {...labelProps}
        />
    </Tooltip>
  );
};

export default ToggleSwitch;